// Spatial layers source names
export const SOURCE_911INFORM = '911inform';
export const SOURCE_CRG = 'crg';
export const SOURCE_GEOCOMM = 'geocomm';
export const STATIC_LAYER_MIN_ZOOM = 13;
